// Grupe stavki bočnog menija. Mapa ide po nazivu rute (ili putanji, kad ruta nema naziv), a ako nje nema, po
// naslovu stavke. Šta nije u mapi ide u "Ostalo", pa nijedna stavka ne nestaje iz menija.
// Naslov grupe: prevod "nav_group_<id>".
export const GROUP_ORDER = ["work", "reports", "money", "catalog", "logistics", "partners", "comms", "system", "other"];

// Redoslijed u nizu je i redoslijed stavki unutar grupe (srodne stavke idu jedna ispod druge).
const BY_ROUTE = {
  work: [
    "jelovnik", "company-menu", "category-menu", "category-menu-group", "additional-meals", "delivery",
    "delivery-user-orders", "supplier-portal",
  ],
  reports: [
    "izvestaj", "izvestajFirma", "izvestaj-naplata", "guest-report", "company-report", "customer-report",
    "izvestaj-posta", "statistics",
  ],
  money: ["restoran-finansije", "ugovori", "company-limits", "restaurant-limits", "restoran-marketing"],
  catalog: ["jela", "kategorije", "restaurant-menu-groups", "menu", "namirnice", "galerija"],
  logistics: ["magacin", "warehouse", "suppliers", "posts", "supplier-codebook", "supplier-drivers", "supplier-drivers-report"],
  partners: [
    "restorani", "firme", "firme-dostava", "users-guest-list", "korisnici", "restoran-id-korisnici", "poslovnice",
    "customer-restaurants", "lokacija", "supplier-restaurants",
  ],
  comms: ["poruke", "outages", "meal-ratings"],
  system: ["/restaurant/settings"],
};

const BY_TITLE = {
  work: ["meal_main", "order", "additional_meals"],
  reports: ["report", "guest_report", "post_report", "statistics"],
  money: ["finance", "contracts_title", "limits", "marketing"],
  catalog: ["meals_main", "groups", "menu_types", "groceri", "gallery"],
  logistics: ["stock", "Trebovanje", "suppliers", "delivery_post"],
  partners: ["restaurants", "companies", "companies_delivery", "users_guest", "customers_restoran", "branches", "location"],
  comms: ["messages", "outages", "meal_ratings"],
  system: ["settings"],
};

// Ikonice bira front (API ih šalje, ali se ponavljaju: tri izvještaja imaju istu). Ključ je naziv rute ili putanja;
// stavka bez ključa u mapi zadržava ikonicu iz API-ja. Ovdje se mijenja ikonica jedne stavke.
const ICONS = {
  jelovnik: "mdi-food-fork-drink",
  "company-menu": "mdi-book-open-page-variant-outline",
  "category-menu": "mdi-shape-outline",
  "category-menu-group": "mdi-folder-outline",
  "additional-meals": "mdi-cup-water",
  delivery: "mdi-moped-outline",
  "delivery-user-orders": "mdi-clipboard-list-outline",
  "supplier-portal": "mdi-truck-delivery-outline",

  izvestaj: "mdi-file-chart-outline",
  izvestajFirma: "mdi-file-table-outline",
  "izvestaj-naplata": "mdi-cash-register",
  "guest-report": "mdi-file-account-outline",
  "company-report": "mdi-file-multiple-outline",
  "customer-report": "mdi-file-eye-outline",
  "izvestaj-posta": "mdi-file-send-outline",
  statistics: "mdi-chart-areaspline",

  "restoran-finansije": "mdi-finance",
  ugovori: "mdi-file-sign",
  "company-limits": "mdi-speedometer",
  "restaurant-limits": "mdi-speedometer",
  "restoran-marketing": "mdi-bullhorn-outline",

  jela: "mdi-food-drumstick-outline",
  kategorije: "mdi-shape-outline",
  "restaurant-menu-groups": "mdi-tag-multiple-outline",
  menu: "mdi-tag-multiple-outline",
  namirnice: "mdi-basket-outline",
  galerija: "mdi-image-multiple-outline",

  magacin: "mdi-warehouse",
  warehouse: "mdi-warehouse",
  suppliers: "mdi-truck-outline",
  posts: "mdi-mailbox-outline",
  "supplier-codebook": "mdi-book-open-variant",
  "supplier-drivers": "mdi-steering",
  "supplier-drivers-report": "mdi-chart-box-outline",

  restorani: "mdi-storefront-outline",
  firme: "mdi-domain",
  "firme-dostava": "mdi-office-building-marker-outline",
  "users-guest-list": "mdi-account-group-outline",
  korisnici: "mdi-account-multiple-outline",
  "restoran-id-korisnici": "mdi-account-multiple-outline",
  poslovnice: "mdi-source-branch",
  "customer-restaurants": "mdi-storefront-outline",
  "supplier-restaurants": "mdi-storefront-outline",
  lokacija: "mdi-map-marker-outline",

  poruke: "mdi-message-text-outline",
  outages: "mdi-flash-off-outline",
  "meal-ratings": "mdi-star-half-full",

  "/restaurant/settings": "mdi-cog-outline",
};

export function navIcon(item) {
  const to = (item && item.to) || {};
  return ICONS[to.name] || ICONS[to.path] || (item && item.icon) || "mdi-circle-small";
}

const lookup = {};
Object.keys(BY_ROUTE).forEach((g) => BY_ROUTE[g].forEach((k) => (lookup["r:" + k] = g)));
Object.keys(BY_TITLE).forEach((g) => BY_TITLE[g].forEach((k) => (lookup["t:" + k] = g)));

// Ključ stavke: naziv rute, inače putanja (isti ključ se čuva u prikačenom i nedavnom).
export function itemKey(item) {
  const to = (item && item.to) || {};
  return to.name || to.path || (item && item.title) || "";
}

export function groupOf(item) {
  const to = (item && item.to) || {};
  return lookup["r:" + (to.name || to.path)] || lookup["t:" + (item && item.title)] || "other";
}

// Grupe se prikazuju samo kad meni ima više od 8 stavki; kraća lista ostaje ravna.
export const GROUP_THRESHOLD = 8;
export const shouldGroup = (items) => (items || []).length > GROUP_THRESHOLD;

// Mjesto stavke unutar grupe po redoslijedu iz mapa iznad; stavke bez mjesta idu na kraj, u redoslijedu menija.
function rankOf(item, id) {
  const to = (item && item.to) || {};
  const byRoute = (BY_ROUTE[id] || []).indexOf(to.name || to.path);
  if (byRoute >= 0) return byRoute;
  const byTitle = (BY_TITLE[id] || []).indexOf(item && item.title);
  return byTitle >= 0 ? byTitle : 1000;
}

// [{ id, items }] u stalnom redoslijedu grupa; srodne stavke su jedna ispod druge po redoslijedu iz mapa.
export function groupMenu(items) {
  const byGroup = {};
  (items || []).forEach((item, index) => {
    const id = groupOf(item);
    (byGroup[id] = byGroup[id] || []).push({ item, index, rank: rankOf(item, id) });
  });
  return GROUP_ORDER.filter((id) => byGroup[id]).map((id) => ({
    id,
    items: byGroup[id].sort((a, b) => a.rank - b.rank || a.index - b.index).map((entry) => entry.item),
  }));
}
